<template>
  <v-dialog v-model="modal.isOpen" persistent min-width="450" max-height="570">
    <v-card append-icon="$close" class="mx-auto" elevation="2" min-width="500">
      <template #append>
        <v-btn
          icon="$close"
          variant="text"
          @click="
            modal.isOpen = false;
            $emit('cancel');
          "
        />
      </template>

      <v-card-text class="text-center py-2">
        <v-icon class="" :color="color" :icon="icon" size="70" />
        <p v-if="modal.title" class="mini-text-dark mt-4 lg text-headline-large font-weight-bold">
          {{ $t(modal.title) }}
        </p>
        <p class="text-body">
          <span style="font-size: 15.75px" v-html="modal.text || ''" />
        </p>
      </v-card-text>

      <!-- TODO - add actions -->
      <v-card-actions
        class="modal__footer modal__buttons justify-center py-4 pa-4 text-end"
      >
        <v-btn
          variant="flat"
          color="primary"
          @click="
            modal.isOpen = false;
            $emit('cancel');
          "
        >
          {{ $t("ok") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AlertModal",
  props: ["isOpen", "title", "text", "confirmText", "variant"],
  data: function () {
    return {
      modal: {
        isOpen: this.isOpen,
        title: this.title,
        text: this.text,
        confirmText: this.confirmText,
        variant: this.variant,
      },
      variants: {
        success: {
          icon: "mdi-check-circle-outline",
          color: "success",
        },
        warning: {
          icon: "mdi-close-outline",
          color: "warning",
        },
        error: {
          icon: "mdi-close-circle-outline",
          color: "#f27474",
        },
        info: {
          icon: "mdi-close-outline",
          color: "blue",
        },
      },
      visible: false,
    };
  },

  computed: {
    color: function () {
      const type = this.modal.variant;
      return this.variants?.[type]?.color || "success";
    },
    icon: function () {
      const type = this?.modal.variant;
      return this.variants?.[type]?.icon || "mdi-info-outline";
    },
  },
  mounted() {
    this.modal.isOpen = this.isOpen;
    this.modal.title = this.title;
    this.modal.text = this.text;
    this.modal.confirmText = this.confirmText;
    this.modal.variant = this.variant;
  },
  methods: {
    // confirm: () =>
    // {
    //     if (this.modal.confirmText)
    //     {
    //         this.$emit('confirm')
    //     }
    // }
  },
};
</script>
